import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import {
  closeHostedOnboardingBrowser,
  toInternalCallbackPath,
} from '../../services/hostedOnboarding';

export function NativeBackButton() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const listener = App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack || window.history.length > 1) {
        navigate(-1);
      } else {
        App.exitApp();
      }
    });

    return () => {
      void listener.then(handle => handle.remove());
    };
  }, [navigate]);

  return null;
}

export function NativeDeepLinks() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const handleUrl = async (url: string) => {
      const path = toInternalCallbackPath(url);
      if (!path) return;
      await closeHostedOnboardingBrowser();
      navigate(path, { replace: true });
    };

    void App.getLaunchUrl().then(result => {
      if (result?.url) void handleUrl(result.url);
    });

    const listener = App.addListener('appUrlOpen', ({ url }) => {
      void handleUrl(url);
    });

    return () => {
      void listener.then(handle => handle.remove());
    };
  }, [navigate]);

  return null;
}
